<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <!-- <v-btn
          text
          :href="`${mediaUrl}`"
          rounded
          color="primary"
          target="_blank"
        >
          <v-icon>mdi-download</v-icon>
          Download sample file
        </v-btn> -->
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Upload Store Gift Data
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col v-if="crud_gifts.length == 0">
              <input
                type="file"
                id="file"
                name="file"
                ref="file"
                accept="application/ms-excel"
                multiple
                @input="handleFileUpload"
              />
              <section v-if="isUploading">
                <v-progress-linear
                  class="mt-5"
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
            </v-col>
            <v-col v-else>
              <v-btn
                color="success"
                :loading="isProcessing"
                :disabled="isProcessing"
                @click="processFile"
              >
                Upload file</v-btn
              >

              &nbsp;
              <v-btn color="error" @click="truncatePendingDocuments">
                Delete</v-btn
              >
            </v-col>
            <div v-if="Conflict_Gifts.length != 0">
              <!-- Export Conflicts -->
              <download-excel
                :title="title"
                class="btn btn-success btn-block"
                :data="conflict_store_gifts_excel"
                :fields="excel_fields"
                worksheet="Conflict_Gifts"
                name="Conflict_Gifts.xls"
              >
                <v-btn color="error">
                  <a href="#" class="download"> Export Conflicts </a></v-btn
                >
              </download-excel>
            </div>
          </v-row>
          <v-row>
            <span style="color: red" v-show="isError">{{ error_msg }} </span>
          </v-row>
        </v-card-text>
      </v-card>
      <br />
      <v-card elevation="6" rounded="xxl">
        <v-card-text>
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Store</th>
                  <th class="text-left">Store Code</th>
                  <th class="text-left">Product</th>
                  <th class="text-left">Quantity</th>
                  <th class="text-left">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(cruduser, at) in crud_gifts" :key="`cruduser${at}`">
                  <td>{{ cruduser.store }}</td>
                  <td>{{ cruduser.store_code }}</td>
                  <td>{{ cruduser.gift }}</td>
                  <td>{{ cruduser.quantity }}</td>
                  <td>{{ cruduser.date }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <!-- Upload Success Dialog Box -->
      <v-dialog v-model="is_Uploaded" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-cloud-upload-outline
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>
                        The file has been uploaded successfully. Now you can
                        Preview the List & process accordingly.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Uploaded = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Process Success Dialog Box -->
      <v-dialog v-model="is_Processed" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-progress-download
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>
                        The file has been processed successfully. Now you can
                        see your users in User's Tab.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Processed = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Truncate Success Dialog Box -->
      <v-dialog v-model="is_Truncated" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: red; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty-outline
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: red">Deleted!</h1>
                      <br />
                      <h3>
                        The file has been deleted successfully. Now you can
                        select a new file to upload.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Truncated = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
// import backbutton from "@/components/backbutton.vue";
export default {
  //   components: { backbutton },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Upload User Excel",
  },
  data() {
    return {
      crud_gifts: [],
      isLoading: false,
      is_mail_sent: false,
      isUploading: false,
      is_Uploaded: false,
      isProcessing: false,
      is_Processed: false,
      is_Truncated: false,
      isError: false,
      error_msg: "",
      path: "",
      Conflict_Gifts: [],
      excel_fields: {
        "sr no": "sr_no",
        store: "store",
        "store code": "store_code",
        gift: "gift",
        quantiy: "quantity",
        date: "date",
      },
      conflict_store_gifts_excel: [],
    };
  },
  mounted() {
    this.getData();
    this.path = this.mediaUrl;
    console.log(this.path);
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true;
      try {
        await axios
          .get(`/crud_gifts`)
          .then((crud_gifts) => {
            this.crud_gifts = crud_gifts.data.data;
            this.count = crud_gifts.data.count;
            this.serialNoStarting = (page - 1) * this.rowsPerPage;
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            // window.location.href = "/auth/login";
          });
      } catch (error) {
        console.log(error);
      }
    },
    async handleFileUpload() {
      this.isUploading = true;
      this.isUploadingError = false;
      this.error_msg = "";
      this.users = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append("gifts", this.users);
      this.changeValue = 100;
      await axios
        .post("crud_gifts/upload_user", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.data) this.crud_gifts = response.data.data;
          this.is_Uploaded = true;
          console.log(this.crud_gifts);
        })
        .catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        });
      this.isUploading = false;
    },
    // async processFile() {
    //   try {
    //     this.isProcessing = true;
    //     await axios.get(`crud_gifts/process_user`).then((data) =>{
    //         this.Conflict_Gifts = data.data.data
    //         console.log("conflict",this.Conflict_Gifts);
    //     }).catch(() => {
    //       this.isError = true;
    //       this.error_msg =
    //         "Looks like system faced an error while processing the File. Kindly check the file before processing ...";
    //     });
    //     this.isProcessing = false;
    //     this.is_Processed = true;
    //     await axios.get("crud_products/truncate_users");
    //     this.crud_products = [];
    //     // alert("Processed Successfully");
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    async processFile() {
      try {
        this.isProcessing = true;
        // Send request and store the response
        const response = await axios.get("crud_gifts/process_user");
        // .then((response) => {
        this.isError = true;
        this.Conflict_Gifts = response.data.data;
        // this.error_msg = "Looks like system faced an error while uploading the File. Kindly check the file before uploading ..."; // "Gift stock is insufficient"
        this.exportToExcel();
        await axios.get("crud_gifts/truncate_users");
        this.crud_gifts = [];
        this.isProcessing = false;
        this.is_Processed = true;
        console.log("conflict", this.Conflict_Gifts);

        // })
        // .catch(async () => {
        //   this.is_Processed = true;
        //   this.isProcessing = false;
        //   await axios.get("crud_gifts/truncate_users");
        //   this.crud_gifts = [];
        // });
        // Check if the response contains an error message
        // if (response.data?.success === false) {
        // } else {
        // }
      } catch (e) {
        this.is_Processed = true;
        await axios.get("crud_gifts/truncate_users");
        this.isProcessing = false;

        this.crud_gifts = [];
        console.log("e==>", e);
      }
    },
    exportToExcel() {
      this.title = "Conflict Gifts Master";
      this.conflict_store_gifts_excel = [];
      let sr_no = 1;
      console.log("execel", this.Conflict_Gifts);

      this.Conflict_Gifts.forEach((store_gift) => {
        this.conflict_store_gifts_excel.push({
          sr_no: sr_no,
          store: store_gift.store ? store_gift.store : "",
          store_code: store_gift.store_code ? store_gift.store_code : "",
          quantity: store_gift.quantity ? store_gift.quantity : "",
          date: store_gift.date ? store_gift.date : "",
          gift: store_gift.gift ? store_gift.gift : "",
        });
        sr_no++;
      });
      console.log("conflict_users_excel", this.conflict_store_gifts_excel);
    },
    async truncatePendingDocuments() {
      try {
        await axios.get("crud_gifts/truncate_users");
        this.is_Truncated = true;
        this.crud_gifts = [];
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
td {
  min-width: 130px !important;
}
</style>
